import { BUS_I, PMIN, PMAX } from "./idx";

const mpcKey = "matpower:/data/mpc";

function case14() {
  return {
    baseMVA: 100,
    bus: [
      [1, 3, 0, 0, 0, 0, 1, 1.06, 0, 69, 1, 1.06, 0.94],
      [2, 2, 21.7, 12.7, 0, 0, 1, 1.045, -4.98, 69, 1, 1.06, 0.94],
      [3, 2, 94.2, 19, 0, 0, 1, 1.01, -12.72, 69, 1, 1.06, 0.94],
      [4, 1, 47.8, -3.9, 0, 0, 1, 1.019, -10.33, 69, 1, 1.06, 0.94],
      [5, 1, 7.6, 1.6, 0, 0, 1, 1.02, -8.78, 69, 1, 1.06, 0.94],
      [6, 2, 11.2, 7.5, 0, 0, 1, 1.07, -14.22, 13.8, 1, 1.06, 0.94],
      [7, 1, 0, 0, 0, 0, 1, 1.062, -13.37, 13.8, 1, 1.06, 0.94],
      [8, 2, 0, 0, 0, 0, 1, 1.09, -13.36, 13.8, 1, 1.06, 0.94],
      [9, 1, 29.5, 16.6, 0, 19, 1, 1.056, -14.94, 13.8, 1, 1.06, 0.94],
      [10, 1, 9, 5.8, 0, 0, 1, 1.051, -15.1, 13.8, 1, 1.06, 0.94],
      [11, 1, 3.5, 1.8, 0, 0, 1, 1.057, -14.79, 13.8, 1, 1.06, 0.94],
      [12, 1, 6.1, 1.6, 0, 0, 1, 1.055, -15.07, 13.8, 1, 1.06, 0.94],
      [13, 1, 13.5, 5.8, 0, 0, 1, 1.05, -15.16, 13.8, 1, 1.06, 0.94],
      [14, 1, 14.9, 5, 0, 0, 1, 1.036, -16.04, 13.8, 1, 1.06, 0.94]
    ],
    branch: [
      [1, 2, 0.01938, 0.05917, 0.0528, 0, 0, 0, 0, 0, 1, -360, 360],
      [1, 5, 0.05403, 0.22304, 0.0492, 0, 0, 0, 0, 0, 1, -360, 360],
      [2, 3, 0.04699, 0.19797, 0.0438, 0, 0, 0, 0, 0, 1, -360, 360],
      [2, 4, 0.05811, 0.17632, 0.034, 0, 0, 0, 0, 0, 1, -360, 360],
      [2, 5, 0.05695, 0.17388, 0.0346, 0, 0, 0, 0, 0, 1, -360, 360],
      [3, 4, 0.06701, 0.17103, 0.0128, 0, 0, 0, 0, 0, 1, -360, 360],
      [4, 5, 0.01335, 0.04211, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [4, 7, 0, 0.20912, 0, 0, 0, 0, 0.978, 0, 1, -360, 360],
      [4, 9, 0, 0.55618, 0, 0, 0, 0, 0.969, 0, 1, -360, 360],
      [5, 6, 0, 0.25202, 0, 0, 0, 0, 0.932, 0, 1, -360, 360],
      [6, 11, 0.09498, 0.1989, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [6, 12, 0.12291, 0.25581, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [6, 13, 0.06615, 0.13027, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [7, 8, 0, 0.17615, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [7, 9, 0, 0.11001, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [9, 10, 0.03181, 0.0845, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [9, 14, 0.12711, 0.27038, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [10, 11, 0.08205, 0.19207, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [12, 13, 0.22092, 0.19988, 0, 0, 0, 0, 0, 0, 1, -360, 360],
      [13, 14, 0.17093, 0.34802, 0, 0, 0, 0, 0, 0, 1, -360, 360]
    ],
    gen: [
      // eslint-disable-next-line
      [1,232.4,-16.9,10,0,1.06,100,1,332.4,0,0,0,0,0,0,0,0,0,0,0,0],
      // eslint-disable-next-line
      [2,40,42.4,50,-40,1.045,100,1,140,0,0,0,0,0,0,0,0,0,0,0,0],
      // eslint-disable-next-line
      [3,0,23.4,40,0,1.01,100,1,100,0,0,0,0,0,0,0,0,0,0,0,0],
      // eslint-disable-next-line
      [6,0,12.2,24,-6,1.07,100,1,100,0,0,0,0,0,0,0,0,0,0,0,0],
      // eslint-disable-next-line
      [8,0,17.4,24,-6,1.09,100,1,100,0,0,0,0,0,0,0,0,0,0,0,0]
    ],
    gencost: [
      [2, 0, 0, 3, 0.0430292599, 20, 0],
      [2, 0, 0, 3, 0.25, 20, 0],
      [2, 0, 0, 3, 0.01, 40, 0],
      [2, 0, 0, 3, 0.01, 40, 0],
      [2, 0, 0, 3, 0.01, 40, 0]
    ],
    dcline: []
  };
}

const MPCStore = {
  data: {
    mpc: case14()
  },
  methods: {
    loadMPC() {
      let data = localStorage.getItem(mpcKey);
      if (data) {
        MPCStore.methods.setMPC(JSON.parse(data));
      }
    },
    saveMPC() {
      let data = JSON.stringify(MPCStore.methods.getMPC());
      if (data) {
        localStorage.setItem(mpcKey, data);
      }
    },
    getMPC() {
      return MPCStore.data.mpc;
    },
    setMPC(mpc) {
      if (!mpc.hasOwnProperty("baseMVA")) mpc.baseMVA = 100;
      if (!mpc.hasOwnProperty("bus")) mpc.bus = [];
      if (!mpc.hasOwnProperty("gen")) mpc.gen = [];
      if (!mpc.hasOwnProperty("branch")) mpc.branch = [];
      if (!mpc.hasOwnProperty("gencost")) mpc.gencost = [];

      mpc.gencost.length = mpc.gen.length;
      for (let i = 0; i < mpc.gencost.length; i++) {
        if (!mpc.gencost[i]) {
          mpc.gencost[i] = [2, 0, 0, 3, 0, 0, 0];
        }
      }

      MPCStore.data.mpc = mpc;
    },

    getBuses() {
      if (!MPCStore.data.mpc.hasOwnProperty("bus")) {
        MPCStore.data.mpc.bus = [];
      }
      return MPCStore.data.mpc.bus;
    },
    getBus(idx) {
      return MPCStore.methods.getBuses()[idx];
    },
    findBusIdx(n) {
      for (let [index, bus] of MPCStore.methods.getBuses().entries()) {
        if (bus[BUS_I] === +n) return index;
      }
      return -1;
    },
    addBus() {
      let buses = MPCStore.methods.getBuses();
      let n = buses.length + 1;
      let bus = [n, 1, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1.05, 0.95];
      buses.push(bus);
      return buses.length - 1;
    },
    deleteBus(idx) {
      MPCStore.methods.getBuses().splice(idx, 1);
    },

    getGens() {
      if (!MPCStore.data.mpc.hasOwnProperty("gen")) {
        MPCStore.data.mpc.gen = [];
      }
      return MPCStore.data.mpc.gen;
    },
    getGen(idx) {
      return MPCStore.methods.getGens()[idx];
    },
    addGen() {
      let base = MPCStore.methods.getMPC().baseMVA;
      // eslint-disable-next-line
      let gen = [1, 0, 0, 100, -100, 1, base, 1, 200, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      MPCStore.methods.getGens().push(gen);
      return MPCStore.methods.getGens().length - 1;
    },
    deleteGen(idx) {
      MPCStore.methods.getGens().splice(idx, 1);
    },
    isLoad: gen => gen[PMIN] < 0 && gen[PMAX] === 0,

    getBranches() {
      if (!MPCStore.data.mpc.hasOwnProperty("branch")) {
        MPCStore.data.mpc.branch = [];
      }
      return MPCStore.data.mpc.branch;
    },
    getBranch(idx) {
      return MPCStore.methods.getBranches()[idx];
    },
    addBranch() {
      let br = [1, 2, 0, 0, 0, 100, 100, 100, 0, 0, 1, -360, 360];
      MPCStore.methods.getBranches().push(br);
      return MPCStore.methods.getBranches().length - 1;
    },
    deleteBranch(idx) {
      MPCStore.methods.getBranches().splice(idx, 1);
    },

    getGenCosts() {
      if (!MPCStore.data.mpc.hasOwnProperty("gencost")) {
        MPCStore.data.mpc.gencost = [];
      }
      return MPCStore.data.mpc.gencost;
    },
    getGenCost(idx) {
      return MPCStore.methods.getGenCosts()[idx];
    },
    addGenCost() {
      let cost = [2, 0, 0, 3, 0, 0, 0];
      MPCStore.methods.getGenCosts().push(cost);
      return MPCStore.methods.getGenCosts().length - 1;
    },
    deleteGenCost(idx) {
      MPCStore.methods.getGenCosts().splice(idx, 1);
    },

    getDCLines() {
      if (!MPCStore.data.mpc.hasOwnProperty("dcline")) {
        MPCStore.data.mpc.dcline = [];
      }
      return MPCStore.data.mpc.dcline;
    },
    getDCLine(idx) {
      return MPCStore.methods.getDCLines()[idx];
    },
    addDCLine() {
      let line = [1, 2, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0];
      MPCStore.methods.getDCLines().push(line);
      return MPCStore.methods.getDCLines().length - 1;
    },
    deleteDCLine(idx) {
      MPCStore.methods.getDCLines().splice(idx, 1);
    }
  }
};

export default MPCStore;
